import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// Preguntas médicas avanzadas de cabeza y cara - Nivel Profesional
export const headQuestionsAdvanced = [
  
  // ============= NIVEL BÁSICO =============
  
  // CONCEPTOS BÁSICOS
  {
    id: 3001,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuál es la función principal del neurocráneo?",
    options: [
      "Formar la estructura facial",
      "Proteger el encéfalo",
      "Articular con la mandíbula",
      "Formar las órbitas oculares"
    ],
    correctAnswer: 1,
    explanation: "El neurocráneo (cráneo neural) tiene como función primaria proteger el encéfalo. Está compuesto por 8 huesos: frontal, occipital, etmoides, esfenoides, 2 parietales y 2 temporales."
  },
  {
    id: 3002,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Qué hueso contiene el foramen magno?",
    options: [
      "Esfenoides",
      "Temporal",
      "Occipital",
      "Etmoides"
    ],
    correctAnswer: 2,
    explanation: "El foramen magno se localiza en el hueso occipital y permite el paso del bulbo raquídeo (médula oblonga), arterias vertebrales, arterias espinales anteriores y posteriores, y las raíces espinales del nervio accesorio (XI par)."
  },
  {
    id: 3003,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura anatómica separa el cráneo en región anterior y posterior?",
    options: [
      "Sutura sagital",
      "Sutura coronal",
      "Sutura lambdoidea",
      "Línea temporal"
    ],
    correctAnswer: 1,
    explanation: "La sutura coronal separa el hueso frontal de los parietales, dividiendo funcionalmente el cráneo en región anterior (frontal) y posterior (parieto-occipital)."
  },

  // ============= NIVEL GENERAL =============
  
  // VASCULARIZACIÓN
  {
    id: 3004,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria es la primera rama de la carótida externa?",
    options: [
      "Arteria tiroidea superior",
      "Arteria lingual",
      "Arteria facial",
      "Arteria faríngea ascendente"
    ],
    correctAnswer: 0,
    explanation: "La arteria tiroidea superior es típicamente la primera rama de la carótida externa, emergiendo justo por debajo del asta mayor del hueso hioides. Irriga la glándula tiroides, laringe y músculos infrahioideos."
  },
  {
    id: 3005,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué rama del nervio trigémino atraviesa el foramen rotundum?",
    options: [
      "Nervio oftálmico (V1)",
      "Nervio maxilar (V2)",
      "Nervio mandibular (V3)",
      "Nervio facial"
    ],
    correctAnswer: 1,
    explanation: "El nervio maxilar (V2), segunda división del trigémino, sale del cráneo a través del foramen rotundum en el ala mayor del esfenoides. Es puramente sensitivo e inerva la región media de la cara."
  },
  {
    id: 3006,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura anatómica pasa por el hiato del canal de Falopio?",
    options: [
      "Nervio petroso superficial mayor",
      "Nervio petroso profundo mayor",
      "Arteria carótida interna",
      "Cuerda del tímpano"
    ],
    correctAnswer: 0,
    explanation: "El nervio petroso superficial mayor (rama del nervio facial) emerge del ganglio geniculado y atraviesa el hiato del canal facial (Falopio) en la porción petrosa del temporal. Conduce fibras parasimpáticas preganglionares para la glándula lagrimal."
  },

  // FUNCIÓN FISIOLÓGICA
  {
    id: 3007,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué músculos son responsables de la elevación del párpado superior?",
    options: [
      "Orbicular del ojo y elevador del párpado",
      "Elevador del párpado superior y músculo de Müller",
      "Recto superior y oblicuo superior",
      "Frontal y corrugador superciliar"
    ],
    correctAnswer: 1,
    explanation: "La elevación del párpado superior es realizada principalmente por el músculo elevador del párpado superior (inervado por el III par craneal) y el músculo tarsal superior o de Müller (inervado por fibras simpáticas). La parálisis del III par causa ptosis."
  },
  {
    id: 3008,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué tipo de epitelio recubre la mayor parte de la cavidad nasal?",
    options: [
      "Epitelio escamoso estratificado",
      "Epitelio cilíndrico pseudoestratificado ciliado",
      "Epitelio de transición",
      "Epitelio cuboidal simple"
    ],
    correctAnswer: 1,
    explanation: "La mucosa respiratoria de la cavidad nasal está recubierta por epitelio cilíndrico pseudoestratificado ciliado con células caliciformes. Los cilios movilizan el moco hacia la nasofaringe. La región olfatoria tiene epitelio especializado con neuronas bipolares."
  },

  // ============= NIVEL COMPLEJO =============
  
  // CASOS CLÍNICOS
  {
    id: 3009,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente masculino de 45 años presenta diplopia al mirar hacia abajo y medialmente. Refiere que el problema empeora al bajar escaleras. ¿Qué nervio craneal está afectado?",
    options: [
      "III par craneal (Oculomotor)",
      "IV par craneal (Troclear)",
      "VI par craneal (Abducens)",
      "V par craneal (Trigémino)"
    ],
    correctAnswer: 1,
    explanation: "La parálisis del IV par craneal (nervio troclear) afecta al músculo oblicuo superior, causando dificultad para la depresión del ojo cuando está en aducción. Clínicamente, los pacientes tienen problemas al bajar escaleras o leer. Compensan con inclinación cefálica hacia el lado contrario a la lesión."
  },
  {
    id: 3010,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente femenina de 60 años con dolor facial unilateral intenso, tipo shock eléctrico, de segundos de duración, desencadenado por masticación. ¿Cuál es el diagnóstico más probable?",
    options: [
      "Arteritis temporal",
      "Neuralgia del trigémino",
      "Migraña hemicraneal",
      "Síndrome de ATM"
    ],
    correctAnswer: 1,
    explanation: "La neuralgia del trigémino (tic doloroso) se caracteriza por episodios paroxísticos de dolor facial unilateral severo, tipo shock eléctrico, de segundos de duración, desencadenados por estímulos táctiles (puntos gatillo). Más común en V2 y V3. Causado frecuentemente por compresión vascular del nervio."
  },
  {
    id: 3011,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Un paciente presenta anestesia del labio inferior y mentón del lado derecho tras extracción de tercer molar. ¿Qué estructura nerviosa se lesionó?",
    options: [
      "Nervio lingual",
      "Nervio alveolar inferior",
      "Nervio bucal",
      "Nervio mentoniano"
    ],
    correctAnswer: 1,
    explanation: "El nervio alveolar inferior (rama del V3) discurre por el canal mandibular y puede lesionarse durante extracciones dentales complejas, especialmente del tercer molar inferior. Su lesión causa anestesia del labio inferior, mentón y encía vestibular inferior del mismo lado. El nervio mentoniano es su rama terminal."
  },
  
  // QUIRÚRGICA
  {
    id: 3012,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "Durante una parotidectomía, ¿qué estructura anatómica debe identificarse para evitar parálisis facial?",
    options: [
      "Arteria carótida externa",
      "Conducto de Stenon",
      "Nervio facial y sus ramas",
      "Vena retromandibular"
    ],
    correctAnswer: 2,
    explanation: "Durante la parotidectomía, la identificación del tronco del nervio facial (VII par) es crítica. El nervio emerge del foramen estilomastoideo y penetra la glándula parótida, dividiéndose en sus cinco ramas terminales (temporal, cigomática, bucal, marginal mandibular y cervical). La lesión causa parálisis facial periférica."
  },
  {
    id: 3013,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Cuál es el plano de disección seguro para acceder al espacio retrofaríngeo en cirugía cervical profunda?",
    options: [
      "Entre la fascia prevertebral y la fascia alar",
      "Entre la fascia alar y la fascia bucofaríngea",
      "Anterior a la fascia pretraqueal",
      "Posterior a la fascia prevertebral"
    ],
    correctAnswer: 1,
    explanation: "El espacio retrofaríngeo está delimitado anteriormente por la fascia bucofaríngea y posteriormente por la fascia alar. Este plano avascular permite el drenaje de colecciones y acceso quirúrgico sin lesionar estructuras neurovasculares importantes. Se extiende desde la base del cráneo hasta el mediastino posterior."
  },

  // IMAGENOLOGÍA
  {
    id: 3014,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En una TC de cráneo sin contraste, ¿qué hallazgo es más sugestivo de fractura de base de cráneo?",
    options: [
      "Hematoma epidural biconvexo",
      "Neumoencéfalo y nivel hidroaéreo en senos paranasales",
      "Desviación de línea media",
      "Hemorragia subaracnoidea difusa"
    ],
    correctAnswer: 1,
    explanation: "El neumoencéfalo (aire intracraneal) y nivel hidroaéreo en senos paranasales son signos radiológicos característicos de fractura de base de cráneo con comunicación de espacios aéreos paranasales y cavidad craneal. Clínicamente se asocia con rinorrea de LCR, otorragia y equimosis periorbitaria (signo del mapache) o retroauricular (signo de Battle)."
  },
  {
    id: 3015,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "¿Qué estructura del oído medio aparece como una imagen en 'tienda de campaña' en la TC de peñasco?",
    options: [
      "Cadena osicular",
      "Nervio facial",
      "Techo del antro mastoideo",
      "Tegmen tympani"
    ],
    correctAnswer: 1,
    explanation: "El nervio facial, en su segmento timpánico (segunda porción), aparece en TC como una estructura en 'tienda de campaña' sobre la ventana oval. El reconocimiento de su trayecto es crucial en cirugía otológica para evitar su lesión durante mastoidectomía o timpanoplastia."
  },

  // EMBRIOLOGÍA
  {
    id: 3016,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué arco faríngeo derivan los músculos de la masticación?",
    options: [
      "Primer arco faríngeo (mandibular)",
      "Segundo arco faríngeo (hioideo)",
      "Tercer arco faríngeo",
      "Cuarto arco faríngeo"
    ],
    correctAnswer: 0,
    explanation: "Los músculos de la masticación (masetero, temporal, pterigoideos medial y lateral) derivan del mesodermo del primer arco faríngeo (arco mandibular), al igual que el vientre anterior del digástrico y los músculos tensor del velo del paladar y tensor del tímpano. Todos son inervados por el nervio mandibular (V3)."
  },
  {
    id: 3017,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿Qué malformación congénita resulta de la falta de fusión de las prominencias nasales mediales?",
    options: [
      "Labio leporino bilateral",
      "Fisura palatina posterior",
      "Macrostomía",
      "Atresia de coanas"
    ],
    correctAnswer: 0,
    explanation: "El labio leporino bilateral resulta de la falta de fusión de las prominencias nasales mediales con las prominencias maxilares durante la 5-8 semana de gestación. El labio leporino puede ser aislado o asociarse con fisura palatina. La fusión incompleta del paladar primario y secundario causa fisura palatina."
  },

  // VARIANTES ANATÓMICAS
  {
    id: 3018,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante más común del polígono de Willis?",
    options: [
      "Ausencia de arteria comunicante posterior",
      "Hipoplasia de segmento A1 de la arteria cerebral anterior",
      "Arteria cerebral posterior con origen fetal (naciendo de la carótida interna)",
      "Duplicación de la arteria cerebral media"
    ],
    correctAnswer: 2,
    explanation: "La variante más común del polígono de Willis es la arteria cerebral posterior con origen fetal (25% de la población), donde nace directamente de la arteria carótida interna en lugar del tronco basilar. La segunda variante más común es la hipoplasia del segmento A1 de la ACA (10-20%). Solo 20-25% tienen un polígono de Willis completamente simétrico."
  },
  {
    id: 3019,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Qué porcentaje de la población presenta un foramen de Huschke persistente?",
    options: [
      "1-2%",
      "5-7%",
      "15-20%",
      "30-35%"
    ],
    correctAnswer: 1,
    explanation: "El foramen de Huschke (dehiscencia de la pared anterior del canal auditivo externo óseo) persiste en aproximadamente 5-7% de adultos. Normalmente se cierra al final del primer año de vida. Su persistencia puede permitir herniación de estructuras de la fosa mandibular o ATM, y es importante en cirugía otológica y de ATM."
  },

  // MÁS CASOS CLÍNICOS COMPLEJOS
  {
    id: 3020,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con parálisis facial periférica, otalgia y vesículas en pabellón auricular. ¿Cuál es el diagnóstico?",
    options: [
      "Parálisis de Bell",
      "Síndrome de Ramsay Hunt",
      "Otitis media complicada",
      "Neuroma del acústico"
    ],
    correctAnswer: 1,
    explanation: "El síndrome de Ramsay Hunt es causado por reactivación del virus varicela-zóster en el ganglio geniculado del nervio facial. Se presenta con parálisis facial periférica, otalgia severa y vesículas herpéticas en el pabellón auricular y conducto auditivo externo. Puede asociarse con hipoacusia neurosensorial y vértigo (afectación del VIII par). Requiere tratamiento antiviral urgente."
  },
  {
    id: 3021,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Cefalea unilateral, ptosis, miosis y anhidrosis facial ipsilateral. ¿Qué síndrome presenta el paciente?",
    options: [
      "Síndrome de Horner",
      "Síndrome de Parinaud",
      "Síndrome de Adie",
      "Síndrome de Argyll Robertson"
    ],
    correctAnswer: 0,
    explanation: "El síndrome de Horner resulta de la interrupción de la vía simpática que inerva el ojo y la cara. La tríada clásica es ptosis (por parálisis del músculo de Müller), miosis (denervación del músculo dilatador de la pupila) y anhidrosis facial. Causas incluyen: tumor de Pancoast, disección carotídea, trauma cervical o lesiones del tronco cerebral."
  },
  {
    id: 3022,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Fractura de la lámina cribosa del etmoides puede resultar en:",
    options: [
      "Epistaxis severa",
      "Anosmia",
      "Diplopía vertical",
      "Trismus"
    ],
    correctAnswer: 1,
    explanation: "La fractura de la lámina cribosa puede seccionar los filetes olfatorios (nervios del I par craneal) que atraviesan sus forámenes, resultando en anosmia (pérdida del olfato). También puede causar rinorrea de LCR y riesgo de meningitis. La anosmia post-traumática puede ser permanente si hay avulsión de los filetes olfatorios del bulbo olfatorio."
  }

  // ... Continuaré generando más preguntas en archivos adicionales
];

// Total actual: 22 preguntas de ejemplo
// Para llegar a 10,000+ necesitamos crear archivos adicionales por región y tipo
